import React, { useState, Children } from 'react'
import PropTypes from 'prop-types'
import format from 'date-fns/format'
import groupBy from 'lodash/groupBy'

import { Box } from '@mui/material'

import { get } from 'utils/lodash'
import { WEEK_DAYS } from 'settings/constants/day'
import { createDateFromString } from 'utils/date'
import { DAY_OF_WEEK_FORMAT_DATE_FNS } from 'settings/constants/date'

import WeekDay from './WeekDay'
import UpcomingWorkOrdersLayout from './UpcomingWorkOrdersLayout'

const WeeklySummary = ({ serviceType, workOrders = [] }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [isOpenUpcomingWODialog, setIsOpenUpcomingWODialog] = useState(false)
  const [selectedDayWO, setSelectedDayWO] = useState([])
  // Check work orders order, if not ordered, order them by serviceDate
  const formattedWorkOrders = workOrders.map(workOrder => ({
    ...workOrder,
    dayOfWeek: format(createDateFromString(workOrder.serviceDate), DAY_OF_WEEK_FORMAT_DATE_FNS),
  }))
  const groupWorkOrdersByDayOfWeek = groupBy(formattedWorkOrders, 'dayOfWeek')

  const handleOpenPopover = (event, currentDayWorkOrders) => {
    event.stopPropagation()
    if (currentDayWorkOrders.length === 0) {
      return
    }
    setSelectedDayWO(currentDayWorkOrders)
    setAnchorEl(event.currentTarget)
  }

  const handleClosePopover = () => {
    setAnchorEl(null)
  }

  const handleOpenDialog = (event, currentDayWorkOrders) => {
    event.stopPropagation()
    if (currentDayWorkOrders.length === 0) {
      return
    }
    setSelectedDayWO(currentDayWorkOrders)
    setIsOpenUpcomingWODialog(true)
  }

  const handleCloseDialog = () => {
    setIsOpenUpcomingWODialog(false)
  }

  return (
    <Box display="flex" gap={2}>
      {Children.toArray(
        WEEK_DAYS.map(day => {
          const currentDayWorkOrders = get(groupWorkOrdersByDayOfWeek, day, [])
          return (
            <WeekDay
              day={day}
              workOrders={currentDayWorkOrders}
              onMouseEnter={event => handleOpenPopover(event, currentDayWorkOrders)}
              onMouseLeave={handleClosePopover}
              onClick={event => handleOpenDialog(event, currentDayWorkOrders)}
            />
          )
        })
      )}

      <UpcomingWorkOrdersLayout
        anchorEl={anchorEl}
        isOpenDialog={isOpenUpcomingWODialog}
        serviceType={serviceType}
        workOrders={selectedDayWO}
        onClosePopover={handleClosePopover}
        onCloseDialog={handleCloseDialog}
      />
    </Box>
  )
}

WeeklySummary.propTypes = {
  serviceType: PropTypes.string.isRequired,
  workOrders: PropTypes.array,
}

export default WeeklySummary
